import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { MatomoProvider, createInstance } from "@mitresthen/matomo-tracker-react";

const urlBase = process.env.REACT_APP_MATOMO_URL_BASE ?? "";
const siteId = parseInt(process.env.REACT_APP_MATOMO_SITE_ID ?? "");

const createMatomoInstance = (urlBase: string, siteId: number, userId: string) => createInstance({
  urlBase,
  siteId,
  userId,
  linkTracking: false,
});

const MatomoTracker: React.FC = ({ children }) => {

  const getContactId = () => {
    const account = msal.instance.getActiveAccount();
    if (account?.idTokenClaims) {
      const contactId = (account.idTokenClaims as any)["contactId"];
      if (typeof contactId === "string") {
        return contactId;
      }
    }
    return void 0;
  }

  const msal = useMsal();
  const location = useLocation();
  const [contactId, setContactId] = useState(getContactId());

  const instance = useMemo(
    () => !!urlBase && !isNaN(siteId) && !!contactId ? createMatomoInstance(urlBase, siteId, contactId) : void 0,
    [contactId]);

  useEffect(() => {
    const instance = msal.instance;
    const callbackId = instance.addEventCallback(() => {
      setContactId(getContactId());
    });
    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, []);

  useEffect(() => {
    if (instance) {
      instance.trackPageView();
    }
  }, [instance, location.pathname]);

  return instance
    ? (
      <MatomoProvider value={instance}>
        {children}
      </MatomoProvider>)
    : (<>
      {children}
    </>);
}

export default MatomoTracker;
